import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { setSplitTitle } from '@scripts/animations/set-split-title'

gsap.registerPlugin(ScrollTrigger)

interface SplitTitle {
  lines: Element[]
  destroy(): void
}

export function footer(element: HTMLElement) {
  // const footerInner = element.querySelector('.js-footer-inner')
  let trigger: GSAPTimeline | null = null
  let mm = gsap.matchMedia()
  let setTitle: SplitTitle

  // get previous section above footer
  const main = element.previousElementSibling
  const parentSection = main ? main.lastElementChild : null

  const title = element.querySelector('.js-title') as HTMLElement
  // const colophon = element.querySelector('.js-colophon') as HTMLElement
  // const contactGroup = element.querySelector('.js-contact-group') as HTMLElement
  if (title) setTitle = setSplitTitle(title)

  // gsap.set([colophon, contactGroup], { autoAlpha: 0 })

  function init(): void {
    mm.add('(min-width: 768px)', () => {
      trigger = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'expo.out'
        },
        scrollTrigger: {
          trigger: parentSection,
          start: `center center`,
          end: `bottom center`,
          scrub: true
        }
      })

      trigger.to(setTitle.lines, { yPercent: 0, stagger: 0.15 })
    })
  }

  function destroy(): void {
    if (trigger && trigger.scrollTrigger) {
      trigger.scrollTrigger.kill() // Kill the ScrollTrigger
      trigger = null
    }
    setTitle.destroy()
    // gsap.set(element, { clearProps: 'all' }) // Clear gsap properties
    mm.revert()
  }

  return {
    init,
    destroy
  }
}
